"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OrganisationInviteError;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _reactRouterDom = require("react-router-dom");

var _InviteAuthProtected = _interopRequireDefault(require("../../../common/components/InviteAuthProtected"));

var _getErrorType = _interopRequireDefault(require("../utils/getErrorType"));

var _constants = require("../constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function OrganisationInviteError(_ref) {
  var error = _ref.error,
      organisation = _ref.organisation,
      userEmail = _ref.userEmail,
      apolloClient = _ref.apolloClient;
  var errorType = (0, _getErrorType.default)(error);

  if (errorType !== _constants.existingOrgMember) {
    return _react.default.createElement(_commonReact.Error, null);
  } // We set the userId to anything because we don't have it at this point and want to ignore it


  return _react.default.createElement(_InviteAuthProtected.default, {
    user: {
      email: userEmail,
      userId: 'userId'
    },
    apolloClient: apolloClient,
    organisationName: organisation.name
  }, function () {
    return _react.default.createElement(_reactRouterDom.Redirect, {
      to: "/"
    });
  });
}